import React, { FC, useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useStores } from 'stores/hooks/hooks';
import styled from 'styled-components';
import Grid from 'components/UI/Grid';
import { TabViewTabChangeEvent } from 'primereact/tabview';
import api from 'Api/ApiMethods';
import MenuBar from './MenuBar';
import CampaignsTable from './CampaignsTable';

const Container = styled(Grid)`
  height: 100%;
  width: 100%;
  justify-content: flex-start;
`;

const StyledMarginGrid = styled(Grid)`
  margin: 1rem 1rem 0 1rem;
  width: 100%;
`;

enum TemplateTabs {
  Template = 0,
}

const CampaignsTab: FC = observer(() => {
  const { campaignsStore } = useStores();

  const [loading, setLoading] = useState<boolean>(false);
  const [activeIndex, setActiveIndex] = useState<TemplateTabs>(
    TemplateTabs.Template,
  );

  const onTabChange = useCallback((e: TabViewTabChangeEvent) => {
    setActiveIndex(e.index);
  }, []);

  useEffect(() => {
    setLoading(true);
    campaignsStore.getAllCampaigns().then(() => {
      setLoading(false);
    });

    return () => {
      campaignsStore.resetCampaigns();
    };
  }, [campaignsStore]);

  return (
    <Container>
      <StyledMarginGrid align="stretch">
        <MenuBar selectedTab={activeIndex} />
        <CampaignsTable
          campaigns={campaignsStore.campaigns}
          isLoading={loading}
        />
      </StyledMarginGrid>
    </Container>
  );
});

export default CampaignsTab;
